import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {IDrawerBoxConfiguration} from "../../../services/configurations/config-data-sections/drawer.configuration";

export interface DrawerBoxProps {
  configData: IDrawerBoxConfiguration
}

export class DrawerBox extends OrbitComponent<DrawerBoxProps> {
  render(): React.ReactNode {
    const translator = this.services.translation;
    return (
      <div className="drawer-box user-challenges-box-wrapper"
           onClick={() => this.services.userMenu.launchDrawerLink(this.props.configData)}>
        <div className="user-challenges-box-picture">
          <a>
            <p className="challenges-box-mobile-title">
              {translator.translate(this.props.configData.text)}
            </p>
          </a>
        </div>
      </div>
    )
  }
}
